import { useEffect, useState } from "react";

const links = [
  { href: "#tracking", label: "事件追踪" },
  { href: "#penalty", label: "官方处罚" },
  { href: "#takedown", label: "下架事件" },
  { href: "#debate", label: "监管争议" },
  { href: "#voices", label: "各方说法" },
  { href: "#timeline", label: "时间线" },
  { href: "#hot", label: "热议区" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-200 ${
        scrolled ? "border-background-200/80 bg-background-50/90 backdrop-blur" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-label text-[15px] font-bold tracking-tight text-foreground-950">快手黑料</span>
            <span className="mt-0.5 hidden text-[11px] text-foreground-500 sm:block">平台风波 · 监管追踪社区</span>
          </span>
        </a>

        <nav className="hidden items-center gap-6 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            围观讨论
          </a>
          <button
            type="button"
            className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            aria-label="打开菜单"
          >
            <i className="ri-menu-line text-lg" />
          </button>
        </div>
      </div>
    </header>
  );
}